import { Grid, type GridProps } from '@chakra-ui/react'
import type { ReactNode } from 'react'
import { StatLabel } from './StatLabel'

interface StatCardProps extends GridProps {
  children: ReactNode
  label: ReactNode
}

export const StatCard = ({ children, label, ...rest }: StatCardProps) =>
  <Grid gap={1} alignContent='space-between' {...rest}>
    {label && <StatLabel mb={1}>{label}</StatLabel>}
    {children}
  </Grid>
